<template src="./guestInfoDetails.template.html"></template>
<script>
import moment from "moment-timezone";
import VeeValidate from "vee-validate";
// import GoogleAutocomplete from 'google-autocomplete-vue';
import VueGoogleAutocomplete from "vue-google-autocomplete";
Vue.use(VeeValidate);
import Vue from "vue";
const phoneOrEmailRule = {
  getMessage(field, args) {
    return `The ${field} must be a valid phone number`;
  },
  validate(value, args) {
    // Custom regex for a phone number
    const MOBILEREG = /^[- +()]*[0-9][- +()0-9]*/;
    // Check for either of these to return true
    return VeeValidate.Rules.email(value) || MOBILEREG.test(value);
  },
};
VeeValidate.Validator.extend("phone", phoneOrEmailRule);
export default {
  name: "guestInfo",
  props: [],
  data() {
    return {
      apiUrl:
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":1339" : ""),
      emailRegEx: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      showGuestDetails: true,
      ShowPaymentDetails: false,
      showTACdetails: false,
      showGuestChangeButton: false,
      showPaymentChangeButton: false,
      showGuestDetail: false,
      // ThankuPage: false,
      selectedUnit: {},
      // guestInfo: {},
      guestInfo: {
        Emailaddress: "",
        PhoneNumber: "",
      },
      loading: false,
      content: {},
      ShowTermsAndConditions: false,
      selectedStateAndCountry: {},
      searchCountry: "",
      searchCity: "",
      searchState: "",
      selectedAddress: "",
      countryList: [],
      cityList: [],
      stateList: [],
      selectedCityObj: {},
      today: moment().format("YYYY-MM-DD HH:mm:ss"),
      ReservationId: -1,
      confirmationNumber: null,
      StatusName: null,
      folioItemCharges: [],
      folioCharges: {},
      additionalEmails: [],
      additionalPhoneNumbers: [],
      paymentCardType: null,
      addressAndZipcodeShow: false,
      isSelectedFromList: false,
      enableCompleteButton: false,
      cardInfo: {
        PaymentTypeId: null,
        NameOnCard: "",
        CreditCard: null,
        PaymentTypeId: null,
        Expirationdate: null,
        CVVCode: null,
        PaymentInfoId: null,
        ExpirationMonth: null,
        ExpirationYear: null,
        AddressDetails: null,
        PostalCode: null,
      },
      stripeConnectedAccount: {},
      stripePlatformAccount: {},
      cardTokenFromStripe: null,
      stripecardId: null,
      cardToken: {},
      paymentLedgerAcounts: [],
      isChecked: false,
      hashUrlReservationId: -1,
      statusId: 10,
      months: [
        { name: "January", value: "01" },
        { name: "February", value: "02" },
        { name: "March", value: "03" },
        { name: "April", value: "04" },
        { name: "May", value: "05" },
        { name: "June", value: "06" },
        { name: "July", value: "07" },
        { name: "August", value: "08" },
        { name: "September", value: "09" },
        { name: "October", value: "10" },
        { name: "November", value: "11" },
        { name: "December", value: "12" },
      ],
      showGuestInfo: true,
      showPriceInfo: false,
      showPriceText: "Details",
      showAddr: false,
      addressText: "Address",
      isWebView: null,
      disableNextStep: false
    };
  },
  methods: {
    closeShoppingCart() {
      let vm = this;
      vm.$store.state.filterObj.startDate = null
      vm.$store.state.filterObj.endDate = null
      
      vm.$store.state.filterObj.RatePlanId = null
      vm.$store.state.filterObj.Promocode = null

      vm.$store.state.bus.$emit("defaultsearchfromfiles", vm.filterObj);
      vm.$router.push("/availabilitySearch");

      // vm.$store.state.bus.$emit("shoppingCart");
      
    },
    showAddress() {
      this.showAddr = !this.showAddr;
      if (this.showAddr) {
        this.addressText = "Close Address";
      } else {
        this.addressText = "Address";
      }
    },
    showPriceDetails() {
      this.showPriceInfo = !this.showPriceInfo;
      if (this.showPriceInfo) {
        this.showPriceText = "Close";
      } else {
        this.showPriceText = "Details";
      }
    },
    resetAddress() {
      let vm = this;
      vm.guestInfo.Address = "";
      // this.$set(this.guestInfo, 'PostalCode', "");
      // this.$set(this.guestInfo, 'CityName', "");
      // this.$set(this.guestInfo, 'StateName', "");
      // this.$set(this.guestInfo, 'CountryName', "");
    },
    // getAddress(address) {
    //     let vm = this;
    //     console.log("addressaddressaddressaddressaddress", address);
    //     vm.guestInfo.Address = address;
    //     var add = address.split(",");
    //     vm.guestInfo.Address = add[0];
    //     console.log("vm.guestInfo.Address",vm.guestInfo.Address);
    // },
    getAddressData: function (addressData, placeResultData, id) {
      console.log("addressData", addressData);
      if (addressData && addressData.street_number && addressData.route) {
        this.guestInfo.Address =
          addressData.street_number + " " + addressData.route;
      } else {
        this.guestInfo.Address = addressData.route;
      }
      if (addressData && addressData.locality) {
        this.$set(this.guestInfo, "CityName", addressData.locality);
      } else if (addressData && addressData.administrative_area_level_2) {
        this.$set(
          this.guestInfo,
          "CityName",
          addressData.administrative_area_level_2
        );
      } else {
        this.$set(this.guestInfo, "CityName", "");
      }
      this.$set(this.guestInfo, "PostalCode", addressData.postal_code);
      this.$set(
        this.guestInfo,
        "StateName",
        addressData.administrative_area_level_1
      );
      this.$set(this.guestInfo, "CountryName", addressData.country);
      this.$set(this.guestInfo, "shortAddress", this.guestInfo.Address);
      console.log("this.guestInfo.PostalCode", this.guestInfo.PostalCode);
    },
    // getAddressData: function (addressData, placeResultData, id) {
    //     this.address = addressData;
    //     console.log("addressData", addressData)
    //     this.$set(this.guestInfo, 'PostalCode', addressData.postal_code);
    //     this.$set(this.guestInfo, 'CityName', addressData.locality);
    //     this.$set(this.guestInfo, 'StateName', addressData.administrative_area_level_1);
    //     this.$set(this.guestInfo, 'CountryName', addressData.country);
    //     console.log("this.guestInfo.PostalCode", this.guestInfo.PostalCode);
    // },
    // changeMethod(field) {
    //     let vm = this;
    //     vm.guestInfo.PostalCode = this.guestInfo.PostalCode;
    //     console.log("vm.guestInfo.PostalCodevm.guestInfo.PostalCode",vm.guestInfo.PostalCode);
    // },
    enableCBbutton() {
      let vm = this;
      console.log("vm.isChecked", vm.isChecked);
      if (vm.isChecked == true) {
        vm.enableCompleteButton = true;
      } else {
        vm.enableCompleteButton = false;
      }
    },
    showTermsAndConditions() {
      let vm = this;
      let routeData = this.$router.resolve({
        name: "termsAndConditions",
        params: { confirmationNumber: vm.$route.params.confirmationNumber },
      });
      window.open(routeData.href, "_blank");
      //    vm.$router.push("/termsAndConditions/" + vm.$route.params.ReservationId);
    },
    showAddressAndZipcode() {
      let vm = this;
      vm.addressAndZipcodeShow = !vm.addressAndZipcodeShow;
    },
    GetCardType(number) {
      let vm = this;
      vm.paymentCardType = null;
      // visa
      var re = new RegExp("^4");
      if (number.match(re) != null) {
        vm.paymentCardType = "Visa";
        // vm.cardInfo.PaymentTypeId = 8;
        return "Visa";
      }
      // Mastercard
      // Updated for Mastercard 2017 BINs expansion
      // if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
      //     {vm.paymentCardType = "MasterCard"
      //     return {cardType:"Mastercard",paymentTypeId:9};
      //     }
      re = new RegExp(
        "^(5[1-5]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2})\\d{0,12}"
      );
      if (number.match(re) != null) {
        vm.paymentCardType = "MasterCard";
        // vm.cardInfo.PaymentTypeId = 9;
        return "Mastercard";
      }
      // AMEX
      re = new RegExp("^3[47]\\d{0,13}"); //new RegExp("^3[47]");
      if (number.match(re) != null) {
        vm.paymentCardType = "American Express";
        // vm.cardInfo.PaymentTypeId = 7;
        return "AMEX";
      }
      // Discover ^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)
      re = new RegExp("(?:6011|65\\d{0,2}|64[4-9]\\d?)\\d{0,12}");
      if (number.match(re) != null) {
        vm.paymentCardType = "Discover";
        // vm.cardInfo.PaymentTypeId = 10;
        return "Discover";
      } else {
        vm.paymentCardType = "Other";
        return "Other";
      }
      // // Diners
      // re = new RegExp("^36");
      // if (number.match(re) != null)
      //   {vm.paymentCardType = "Diners"
      //   return {cardType:"Diners",paymentTypeId:7};}
      // // Diners - Carte Blanche
      // re = new RegExp("^30[0-5]");
      // if (number.match(re) != null)
      //   {vm.paymentCardType = "Diners"
      //   return {cardType:"Diners - Carte Blanche",paymentTypeId:7};}
      // // JCB
      // re = new RegExp("^35(2[89]|[3-8][0-9])");
      // if (number.match(re) != null)
      //   {vm.paymentCardType = "JCB"
      //   return {cardType:"JCB",paymentTypeId:7};}
      // // Visa Electron
      // re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
      // if (number.match(re) != null)
      //   {vm.paymentCardType = "Visa Electron"
      //   return {cardType:"Visa Electron",paymentTypeId:7};}
      return "";
    },
    GetReservationDetailById: function () {
      let vm = this;
      console.log("vm.hashUrlReservationId======?", vm.hashUrlReservationId);
      if (vm.hashUrlReservationId == "-1") {
        console.log("vm.unit", vm.unit);
        vm.selectedUnit = vm.unit;
        vm.showGuestDetails = true;
        vm.ShowPaymentDetails = false;
        // vm.ThankuPage = false;
        vm.GetFolioLedgerTransDetails_beforesave();
      } else {
        vm.showGuestDetails = true;
        vm.ShowPaymentDetails = false;
        // vm.ThankuPage = false;
      }
      let obj = {
        ModuleAction: "GetReservationDetailById",
        ReservationId: vm.hashUrlReservationId,
        BE_Id: null,
      };
      let sucessCallback = function (response) {
          if (response.data) {
            console.log("GetReservationDetailById====>cv", response.data);
            vm.guestInfo = response.data.guestInfo;
            console.log("vm.guestInfo", vm.guestInfo);
            vm.guestInfo.Emailaddress =
              response.data.additionalEmails &&
              response.data.additionalEmails[0] &&
              response.data.additionalEmails[0].Emailaddress
                ? response.data.additionalEmails[0].Emailaddress
                : vm.guestInfo.Email;
            vm.guestInfo.PhoneNumber =
              response.data.additionalPhoneNumbers &&
              response.data.additionalPhoneNumbers[0] &&
              response.data.additionalPhoneNumbers[0].PhoneNumber
                ? response.data.additionalPhoneNumbers[0].PhoneNumber
                : vm.guestInfo.PhoneNumber;
            vm.searchCity = response.data.guestInfo.CityName;
            vm.searchCountry = response.data.guestInfo.CountryName;
            vm.searchState = response.data.guestInfo.StateName;
            if (response.data.roomInfo.UnitId) {
              vm.selectedUnit = response.data.roomInfo;
              vm.filterObj.startDate = response.data.roomInfo.originalStartDate;
              vm.filterObj.endDate = response.data.roomInfo.originalEndDate;
              vm.filterObj.Adults = response.data.roomInfo.NumberOfAdults;
              vm.filterObj.Children = response.data.roomInfo.NumberOfChildren;
              vm.filterObj.Persons = response.data.roomInfo.Persons;
              vm.filterObj.RatePlanId = response.data.guestInfo.RatePlanId;
              vm.filterObj.Promocode = response.data.guestInfo.Promocode;
              vm.statusId = response.data.roomInfo.Reservation_Status;
            }
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/GetReservationDetailById",
        "post",
        obj,
        sucessCallback,
        failureCallback
      );
    },
    formatMoney(amount) {
      return this.$store.state.getFormattedAmount("$", amount);
    },
    saveGuestInfo: function () {
      let vm = this;
      document.getElementById("custom-nav-bar").style.display = "";
      vm.showPaymentChangeButton = false;
      if (
        vm.guestInfo &&
        vm.guestInfo.Emailaddress &&
        vm.guestInfo.Emailaddress != "" &&
        vm.guestInfo.Emailaddress != null &&
        vm.guestInfo.GuestFirstName != null &&
        vm.guestInfo.GuestLastName != null &&
        vm.guestInfo.PhoneNumber != null &&
        vm.guestInfo.PhoneNumber != ""
      ) {
        vm.showGuestChangeButton = true;
      }
      // if (vm.ShowPaymentDetails == false) {
      //     vm.showGuestChangeButton = false;
      // }
      vm.$validator.validateAll().then((result) => {
        if (result) {
          if (!vm.emailRegEx.test(vm.guestInfo.Emailaddress)) {
            //console.log("Invalid email");
            vm.$store.dispatch("toastr", {
              type: "warning",
              message: "Please enter valid E-mail Id",
              header: "Email",
            });
            return;
          }
          vm.disableNextStep = true
          vm.additionalPhoneNumbers.splice(
            0,
            vm.additionalPhoneNumbers.length,
            { ReservationId: "", PhoneNumber: vm.guestInfo.PhoneNumber }
          );
          vm.additionalEmails.splice(0, vm.additionalEmails.length, {
            ReservationId: "",
            Emailaddress: vm.guestInfo.Emailaddress,
          });
          vm.showGuestDetails = true;
          // vm.ShowPay = true;
          // vm.ThankuPage = false;
          // vm.ReservationId = -1
          let obj = {
            ModuleAction: "saveReservation_GuestInfo",
            AddressTypeId: 1,
            GuestFirstName: vm.guestInfo.GuestFirstName,
            GuestLastName: vm.guestInfo.GuestLastName,
            PhoneNumber: vm.guestInfo.PhoneNumber,
            Email: vm.guestInfo.Emailaddress,
            Address1: vm.guestInfo.Address,
            Address2: vm.guestInfo.AddressDetails2,
            Address3: vm.guestInfo.AddressDetails3,
            PostalCode: vm.guestInfo.PostalCode,
            CityId: vm.selectedStateAndCountry.CityId,
            CountryId: vm.selectedStateAndCountry.CountryId,
            StateId: vm.selectedStateAndCountry.StateId,
            cityName: vm.guestInfo.CityName,
            stateName: vm.guestInfo.StateName,
            countryName: vm.guestInfo.CountryName,
            StatusId: vm.statusId,
            PartyAddressId: null,
            SourceId:
              vm.guestInfo && vm.guestInfo.SourceId ? vm.guestInfo.SourceId : 9,
            SubSourceId: null,
            CrsId: null,
            ReservationId: vm.hashUrlReservationId,
            Ext_ReservationId:
              vm.guestInfo && vm.guestInfo.ReservationNumber
                ? vm.guestInfo.ReservationNumber
                : null,
            ClientPrice: null,
            SelectedTags: null,
            StayInfoId: null,
            UpdatedDate: vm.today,
            additionalEmails: vm.additionalEmails,
            additionalPhoneNumbers: vm.additionalPhoneNumbers,
          };
          let sucessCallback = function (response) {
             vm.disableNextStep = false
              if (response.data) {
                console.log("response.data====>", response.data);
                if (response.data[2]) {
                  vm.hashUrlReservationId = response.data[2][0].ReservationId;
                  console.log(
                    " vm.hashUrlReservationId--->",
                    vm.hashUrlReservationId
                  );
                }
                vm.assignRooms(vm.hashUrlReservationId);
                if (window.outerWidth <= 1024) {
                  vm.scrollPaymentPage();
                }
              }
            },
            failureCallback = function (error) {
              console.log(error);
               vm.disableNextStep = false
            };
            console.log("propertyid=======>", vm.selectedUnit.PropertyId);
         

          vm.$store.state.sendApiRequest(
            "beApi/saveReservation_GuestInfo",
            "post",
            obj,
            sucessCallback,
            failureCallback
          );
        }
      });
    },
  
    scrollPaymentPage() {
      let vm = this;
      if (vm.isWebView == false && window.innerHeight < window.innerWidth) {
        console.log(
          "gdsafffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
        );
        // setTimeout(() => {
        // var etop = $(".dataPanelSlide").offset().top - 75;
        // $('html, body').animate({
        //     scrollTop: etop
        // }, 350);hn
        // }, 100)
        // $("html, body").animate({ scrollTop: 0 });
      } else {
        $("html, body").animate({ scrollTop: 0 });
      }
    },
    formatEndDate(date) {
      let vm = this;
      let startYear = moment(
        vm.$store.state.filterObj.startDate,
        "YYYY-MM-DD"
      ).format("YYYY");
      let endYear = moment(
        vm.$store.state.filterObj.endDate,
        "YYYY-MM-DD"
      ).format("YYYY");
      return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
    },
    formatStartDate(date) {
      let vm = this;
      let startYear = moment(
        vm.$store.state.filterObj.startDate,
        "YYYY-MM-DD"
      ).format("YYYY");
      let endYear = moment(
        vm.$store.state.filterObj.endDate,
        "YYYY-MM-DD"
      ).format("YYYY");
      if (startYear == endYear) {
        return moment(date, "YYYY-MM-DD").format("DD MMM ");
      } else {
        return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
      }
    },
    assignRooms: function (resid) {
      let vm = this;
      vm.filterObj.Persons = vm.$store.state.filterObj.Persons == -99 || vm.$store.state.filterObj.Persons == '' ? null : vm.$store.state.filterObj.Persons;
      vm.filterObj.Adults = vm.$store.state.filterObj.Adults == -99 || vm.$store.state.filterObj.Adults == '' ? null : vm.$store.state.filterObj.Adults;
      vm.filterObj.Children = vm.$store.state.filterObj.Children == -99 || vm.$store.state.filterObj.Children == '' ? null : vm.$store.state.filterObj.Children;
      let text =
        "Booking reservation from guest info page." + vm.selectedUnit.NickName;
        if(vm.$gtag){
          vm.$gtag.event('Booking reservation from guest info page', {
            'event_category': 'Booking unit',
            'event_label': 'Booking unit',
          })
        }
      let obj = {
        ModuleAction: "SaveReservation_AssignRooms",
        PropertyId: vm.selectedUnit.PropertyId,
        StatusId: vm.statusId,
        NumberOfAdults: vm.filterObj.Adults,
        NumberOfChildren: vm.filterObj.Children,
        ReservationId: resid,
        UnitId: vm.selectedUnit.UnitId,
        StartDate: moment(vm.filterObj.startDate).format("YYYY-MM-DD"),
        EndDate: moment(vm.filterObj.endDate).format("YYYY-MM-DD"),
        Ext_ReservationId:
          vm.guestInfo && vm.guestInfo.ReservationNumber
            ? vm.guestInfo.ReservationNumber
            : null,
        Persons: vm.filterObj.Persons,
        SourceId:
          vm.guestInfo && vm.guestInfo.SourceId ? vm.guestInfo.SourceId : 9,
        StayInfoId: -1,
        ReservationMode: 0,
        PreviousRoomInfo: null,
        RecalculateFolio: 0,
        Promocode: vm.filterObj.Promocode,
        RatePlanId: vm.filterObj.RatePlanId,
      };
      let sucessCallback = function (response) {
          if (response.data) {
            console.log("guest info", response.data);
            if (response.data[7]) {
              vm.confirmationNumber =
                response.data[7][0].TempoConfirmationNumber;
              console.log("vm.confirmationNumber", vm.confirmationNumber);
            }
            if (response.data[3]) {
              vm.StatusName = response.data[3][0].StatusName;
            }
            // vm.saveNotesDetails(-1, 0, 0);
            vm.ShowPaymentDetails = false;
            // if (vm.ShowPaymentDetails = true) {
            //     vm.showGuestChangeButton = true;
            // }
            vm.showGuestDetails = true;
            vm.ShowTermsAndConditions = false;
            if (vm.$route.params.confirmationNumber == -1) {
              vm.saveNotesDetails(-1, 0, 0);
              vm.generateHashKey(vm.confirmationNumber,response.data);
            } else {
              // console.log("/paymentInfo/", vm.hashUrlReservationId)
              console.log("/paymentInfo/", vm.$route.params.confirmationNumber);
              vm.$router.push(
                "/paymentInfo/" +
                  encodeURIComponent(vm.$route.params.confirmationNumber)
              );
            }
            // vm.$router.push("/guestInfoAndPayment/" + vm.confirmationNumber);
            // vm.Get_FolioSummary();
            vm.getPaymentDetails();
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/SaveReservation_AssignRooms",
        "post",
        obj,
        sucessCallback,
        failureCallback
      );
    },
    generateHashKey(confirmationNumber,resData) {
      let vm = this;
      let obj = {
          confirmationNumber: confirmationNumber,
        },
        sucessCallback = function (response) {
          if (response.data) {
            vm.Save_HashURL(response.data, confirmationNumber);
            console.log("/paymentInfo/", response.data);
            if(resData[6] && resData[6][0]){
              if(vm.$gtag){
                vm.$gtag.event('add_to_cart', {
                  // transaction_id: "HT" + confirmationNumber,
                  value: vm.folioCharges.TotalValue,
                  // tax: vm.folioCharges.TotalTax,
                  // shipping: 0,
                  currency: 'USD',
                  CheckinDate: moment(resData[6][0].arrivalDate).format("YYYY-MM-DD"),
                  BookedDate: moment(resData[6][0].BookedDate).format("YYYY-MM-DD"),
                  Nights: resData[6][0].Nights,
                  UnitTypeName: resData[6][0].UnitTypeName,
                  UnitClassName: resData[6][0].UnitClassName,
                  ADR: vm.folioItemCharges[0].Adr,
                  RateplanName: resData[6][0].RateplanName,
                  CheckoutDate: moment(resData[6][0].departureDate).format("YYYY-MM-DD"),
                  ClientCode: resData[6][0].ClientCode,
                  UnitCharge: vm.folioItemCharges[0].Charges,
                  CleaningFee: vm.folioItemCharges[1].Charges,
                  PropertyName: resData[6][0].PropertyName,
                  page_title: "Guest Info-Page",
                  items: [
                    {
                      item_id: "HT" + confirmationNumber,
                      item_name: resData[6][0].PropertyNickName +"(" + resData[6][0].UnitNickName +")",
                      quantity: 1,
                      price: vm.folioCharges.TotalValue,
                    },
                  ],
                }); 
              }
          }
            vm.$router.push(
              "/paymentInfo/" + encodeURIComponent(response.data)
            );
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/generateHashKey",
        "post",
        obj,
        sucessCallback,
        failureCallback
      );
    },
    Save_HashURL(hashKey, confirmationNumber) {
      let vm = this;
      // let hashKeyValue = hashKey.replace(/\//g, "");
      // hashKeyValue = hashKeyValue.replace(/#/g, "");
      let obj = {
        HashURL: hashKey,
        fromQuote: false,
        ReservationId: vm.hashUrlReservationId,
        confirmationNumber: confirmationNumber,
      };
      let sucessCallback = function (response) {
          if (response) {
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/Save_HashURL",
        "post",
        obj,
        sucessCallback,
        failureCallback
      );
      // vm.$router.push("/guestInfoAndPayment/" + hashKey.toString());
      // vm.$router.push({ name: 'guestInfoDetails', params: { confirmationNumber: hashKey } });
      vm.Get_FolioSummary();
    },
    saveNotesDetails(noteId, noteStatusId, sendEmail) {
      let vm = this,
        obj = {
          ReservationId: vm.hashUrlReservationId,
          NoteId: noteId,
          NoteTypeId: 2,
          noteStatusId: 0,
          taskTypeId: 1,
          isAutoGenerated: 1,
          NoteSubject: "Turnover cleaning",
          NoteDetails: "Turnover cleaning",
          IsActionReqd: 1,
          DateOrTimeDue: moment(vm.filterObj.endDate).format("YYYY-MM-DD"),
          reCalculateFolio: true,
          sendEmail: sendEmail,
          unitId: vm.selectedUnit.UnitId,
        },
        sucessCallback = function (response) {
          if (response.data) {
            console.log("guest info", response.data);
            vm.Get_FolioSummary();
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/SaveNotesDetails",
        "post",
        obj,
        sucessCallback,
        failureCallback
      );
    },
    onChangeCountry: function (country) {
      let vm = this;
      $(".searchResultsCities").hide();
      vm.selectedStateAndCountry.CountryName = country.CountryName;
      vm.selectedStateAndCountry.CountryId = country.CountryId;
      vm.searchCountryOldValue = country.CountryName;
      vm.searchCountry = country.CountryName;
      vm.countryList = [];
    },
    onChangeCity: function (CityId) {
      let vm = this;
      $(".searchResultsCities").hide();
      let obj = {
        ModuleAction: "GetCityStateCountryById",
        CityId: CityId,
      };
      let sucessCallback = function (response) {
          console.log("response in searchCity", response);
          if (response.data) {
            let selectedoptions = null;
            selectedoptions = response.data;
            vm.searchCityOldValue = selectedoptions.CityName;
            vm.searchCountryOldValue = selectedoptions.CountryName;
            vm.searchStateOldValue = selectedoptions.StateName;
            vm.selectedStateAndCountry = selectedoptions;
            vm.searchCity = selectedoptions.CityName;
            vm.searchCountry = selectedoptions.CountryName;
            vm.searchState = selectedoptions.StateName;
            vm.cityList = [];
            vm.isSelectedFromList = true;
            //   vm.isCitySelected = true;
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/GetCityStateCountryById",
        "post",
        obj,
        sucessCallback,
        failureCallback
      );
    },
    onChangeState: function (state) {
      let vm = this;
      $(".searchResultsCities").hide();
      let obj = {
        ModuleAction: "GetCountryByStateId",
        StateId: state.StateId,
      };
      let sucessCallback = function (response) {
          console.log("response in searchCity", response);
          if (response.data) {
            vm.selectedStateAndCountry.StateName =
              response.data[0][0].StateName;
            vm.selectedStateAndCountry.StateId = response.data[0][0].StateId;
            vm.selectedStateAndCountry.CountryName =
              response.data[0][0].CountryName;
            vm.selectedStateAndCountry.CountryId =
              response.data[0][0].CountryId;
            vm.searchStateOldValue = response.data[0][0].StateName;
            vm.searchCountryOldValue = response[0][0].CountryName;
            vm.searchCountry = response.data[0][0].CountryName;
            vm.searchState = response.data[0][0].StateName;
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/GetCountryByStateId",
        "post",
        obj,
        sucessCallback,
        failureCallback
      );
    },
    formatDate(date) {
      return moment(date, "YYYY-MM-DD").format("DD MMM ");
    },
    imageURLS(imgGuid) {
      let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
      if (isBase64) {
        return imgGuid;
      }
      return this.apiUrl + "/downloadImage/" + imgGuid + "/430x300";
    },
    showPayment() {
      let vm = this;
      vm.showGuestDetails = false;
      vm.ShowPaymentDetails = false;
      vm.showTACdetails = false;
      vm.showGuestDetail = true;
      vm.showPaymentChangeButton = false;
      vm.showGuestChangeButton = true;
      vm.ShowTermsAndConditions = false;
      console.log("/paymentInfo/", vm.hashUrlReservationId);
      vm.$router.push("/paymentInfo/" + vm.hashUrlReservationId);

      // vm.ThankuPage = false;
    },
    showTAC() {
      let vm = this;
      if (window.outerWidth <= 1024) {
        vm.scrollPaymentPage();
      }
      let currentYear = moment().format("YYYY");
      let currentMonth = moment().format("MM");
      if (
        !vm.cardInfo.CreditCard ||
        vm.cardInfo.CreditCard.length < 10 ||
        vm.cardInfo.CreditCard.length > 16
      ) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please enter valid card number",
        });
        return;
      } else if (isNaN(vm.cardInfo.CreditCard)) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please enter valid card number",
        });
        return;
      } else if (vm.cardInfo.ExpirationMonth == -1) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please select expiry month",
        });
        return;
      } else if (vm.cardInfo.ExpirationYear == -1) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please select expiry year",
        });
        return;
      } else if (
        Number(vm.cardInfo.ExpirationMonth) < currentMonth &&
        Number(vm.cardInfo.ExpirationYear) <= currentYear
      ) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please select valid expiry month/year",
        });
        return;
      }
      // else if (!vm.cardInfo.CVVCode) {
      //     vm.$store.dispatch("toastr", {
      //         type: "warning",
      //         header: "Warning!",
      //         message: "Please enter CVV"
      //     });
      //     return;
      // }
      // else if (vm.cardInfo.CVVCode.length < 3 || vm.cardInfo.CVVCode.length > 4) {
      //     vm.$store.dispatch("toastr", {
      //         type: "warning",
      //         header: "Warning!",
      //         message: "Please enter valid CVV"
      //     });
      //     return;
      // }
      else {
        vm.showGuestDetails = false;
        vm.ShowPaymentDetails = false;
        vm.ShowTermsAndConditions = true;
        vm.showTACdetails = true;
        vm.showPaymentChangeButton = true;
        vm.showGuestDetail = true;
        vm.showGuestChangeButton = true;
        vm.cardInfo.CCLast4Digits = vm.cardInfo.CreditCard
          ? vm.cardInfo.CreditCard.substring(12, 16)
          : null;
      }
      
      // vm.ThankuPage = false;
    },
    showGuest() {
      let vm = this;
      vm.showGuestDetails = true;
      vm.ShowPaymentDetails = false;
      vm.showTACdetails = false;
      vm.showPaymentChangeButton = false;
      if (vm.showGuestDetails == true) {
        vm.showGuestChangeButton = false;
      } else {
        vm.showGuestChangeButton = true;
      }
      // vm.$gtag.event({

      //     eventCategory: 'Change Button',
      //     eventAction: 'Guest Info Change'
      // })
      // vm.ThankuPage = false;
    },
    Get_FolioSummary: function () {
      let vm = this;
      let obj = {
        ModuleAction: "Get_FolioSummary",
        ReservationId: vm.hashUrlReservationId,
      };
      let sucessCallback = function (response) {
          if (response.data) {
            vm.folioItemCharges = response.data[0];
            vm.folioCharges = response.data[2][0];
            console.log("Get_FolioSummary", response.data);
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/Get_FolioSummary",
        "post",
        obj,
        sucessCallback,
        failureCallback
      );
    },
    GetFolioLedgerTransDetails_beforesave() {
      let vm = this;
      vm.filterObj.Persons = vm.$store.state.filterObj.Persons == -99 || vm.$store.state.filterObj.Persons == '' ? null : vm.$store.state.filterObj.Persons;
      vm.filterObj.Adults = vm.$store.state.filterObj.Adults == -99 || vm.$store.state.filterObj.Adults == '' ? null : vm.$store.state.filterObj.Adults;
      vm.filterObj.Children = vm.$store.state.filterObj.Children == -99 || vm.$store.state.filterObj.Children == '' ? null : vm.$store.state.filterObj.Children;
      if (vm.$route.params.confirmationNumber != -1) {
        console.log("here1");
        vm.Get_FolioSummary();
        return;
      }
      let obj = {
        FolioId: null,
        ReservationId: null,
        UnitId: vm.selectedUnit.UnitId,
        PropertyId: vm.selectedUnit.PropertyId,
        StartDate: vm.$store.state.filterObj.startDate,
        EndDate: vm.$store.state.filterObj.endDate,
        NumOfAdults: vm.filterObj.Adults,
        NumOfChildren: vm.filterObj.Children,
        Persons: vm.filterObj.Persons,
        RatePlanId: vm.$store.state.filterObj.RatePlanId,
      };
      vm.folioItemCharges = [];
      vm.folioCharges = {};
      console.log("obj", obj);
      let sucessCallback = function (response) {
          console.log("response in GetFolioLedgerTransDetails", response);
          if (response && response.data) {
            if (response.data[0]) {
              vm.folioItemCharges = response.data[0];
            }
            if (response.data[2]) {
              vm.folioCharges = response.data[2][0];
            }
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/GetFolioLedgerTransDetails",
        "post",
        obj,
        sucessCallback,
        failureCallback
      );
    },
    showThankPage() {
      let vm = this;
      vm.showGuestDetails = false;
      // vm.ShowPay = false;
      // vm.ThankuPage = true;
      vm.savePaymentDetails();
    },
    updateStartDate(key, dateObj) {
      let scope = this;
      scope.cardInfo.Expirationdate = dateObj
        ? dateObj.format("MMM YYYY")
        : null;
      scope.cardInfo.ExpirationMonth = moment(
        scope.cardInfo.Expirationdate
      ).format("MM");
      scope.cardInfo.ExpirationYear = moment(
        scope.cardInfo.Expirationdate
      ).format("YYYY");
      console.log(
        "scope.cardInfo.ExpirationMonth",
        scope.cardInfo.ExpirationMonth
      );
    },
    getCardToken() {
      let vm = this;
      // if(vm.cardInfo.NameOnCard == "" || vm.cardInfo.NameOnCard == null){
      //     vm.$store.dispatch("toastr", {
      //         type: "warning",
      //         message: "Please Enter Name On Card",
      //         header: "Warning"
      //     });
      //     return;
      // }
      // else if(){
      // }
      vm.enableCompleteButton = false;
      vm.loading = true;
      console.log("vm.stripeConnectedAccount", vm.stripeConnectedAccount);
      let currentYear = moment().format("YYYY");
      let currentMonth = moment().format("MM");
      if (vm.stripeConnectedAccount == null) {
        (vm.loading = false), (vm.enableCompleteButton = true);
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please connect stripe account",
        });
        return;
      } else if (vm.isChecked == false) {
        (vm.loading = false), (vm.enableCompleteButton = false);
        vm.$store.dispatch("toastr", {
          type: "warning",
          message: "Please Check Terms And Conditions To Proceed",
          header: "Warning",
        });
        return;
      } else if (
        !vm.cardInfo.CreditCard ||
        vm.cardInfo.CreditCard.length < 10 ||
        vm.cardInfo.CreditCard.length > 16
      ) {
        (vm.loading = false), (vm.enableCompleteButton = true);
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please enter valid card number",
        });
        return;
      } else if (isNaN(vm.cardInfo.CreditCard)) {
        (vm.loading = false), (vm.enableCompleteButton = true);
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please enter valid card number",
        });
        return;
      } else if (vm.cardInfo.ExpirationMonth == -1) {
        (vm.loading = false), (vm.enableCompleteButton = true);
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please select expiry month",
        });
        return;
      } else if (vm.cardInfo.ExpirationYear == -1) {
        (vm.loading = false), (vm.enableCompleteButton = true);
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please select expiry year",
        });
        return;
      } else if (
        Number(vm.cardInfo.ExpirationMonth) < currentMonth &&
        Number(vm.cardInfo.ExpirationYear) <= currentYear
      ) {
        (vm.loading = false), (vm.enableCompleteButton = true);
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning!",
          message: "Please select valid expiry month/year",
        });
        return;
      }
      // else if (!vm.cardInfo.CVVCode || vm.cardInfo.CVVCode.length < 3 || vm.cardInfo.CVVCode.length > 4) {
      //     vm.loading = false,
      //         vm.enableCompleteButton = false;
      //     vm.$store.dispatch("toastr", {
      //         type: "warning",
      //         header: "Warning!",
      //         message: "Please enter valid CVV"
      //     });
      //     return;
      // }
      let obj = {
          NameOnCard: vm.cardInfo.NameOnCard,
          CreditCard: vm.cardInfo.CreditCard,
          ExpirationMonth: vm.cardInfo.ExpirationMonth,
          ExpirationYear: vm.cardInfo.ExpirationYear,
          CVVCode: vm.cardInfo.CVVCode,
          AddressDetails: vm.cardInfo.AddressDetails,
          PostalCode: vm.cardInfo.PostalCode,
        },
        guestInfo = vm.guestInfo,
        email = vm.guestInfo.Emailaddress,
        phone = vm.guestInfo.PhoneNumber,
        sk_token = vm.stripePlatformAccount.SecretKey,
        stripeConnectedAccount = vm.stripeConnectedAccount;
      console.log("obj", obj);
      let sucessCallback = function (response) {
          console.log("response in getCardToken", response);
          if (response && response.data && response.data.message) {
            vm.Save_ErrorLogs(response.data.message);
            console.log("response.data.message", response.data.message);
            vm.loading = false;
            vm.enableCompleteButton = true;
            vm.$store.dispatch("toastr", {
              type: "error",
              message: "Please enter valid card details",
              header: "Error",
            });
            return;
          }
          // else {
          //     vm.$store.dispatch("toastr", {
          //         type: "success",
          //         header: "Success!",
          //         message: "Payments Saved Successfully!"
          //     });
          // }
          if (response && response.data) {
            vm.cardToken = response.data.token.card;
            vm.cardTokenFromStripe = response.data.customer.id;
            vm.stripecardId = response.data.customer.default_source;
            console.log("vm.cardTokenFromStripe", vm.cardTokenFromStripe);
            vm.savePaymentCardDetails();
            if(vm.$gtag){
              vm.$gtag.event("Booking Completed", {
                'event_category': 'Payment',
                'event_label': 'Payment',
              })
            }
          }
            
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/getCardToken",
        "post",
        {
          cardInfo: obj,
          sk_token,
          guestInfo,
          email,
          phone,
          stripeConnectedAccount,
        },
        sucessCallback,
        failureCallback
      );
    },
    // tax
    Save_ErrorLogs(errorMessage) {
      let vm = this,
        obj = {
          PartyId: vm.hashUrlReservationId,
          PartyTypeId: 5,
          ErrorFrom: "SavePaymentDetails",
          RawResponse: errorMessage,
        };
      let sucessCallback = function (response) {
          console.log("response in Save_ErrorLogs", response);
          if (response && response.data) {
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/Save_ErrorLogs",
        "post",
        obj,
        sucessCallback,
        failureCallback
      );
    },
    // tax
    savePaymentCardDetails() {
      let vm = this;
      for (let ledger of vm.paymentLedgerAcounts) {
        if (vm.paymentCardType === ledger.PaymentMethod) {
          vm.cardInfo.PaymentTypeId = ledger.ledgerAccountID;
        }
      }
      let obj = {
          PaymentInfoId: vm.cardInfo.PaymentInfoId,
          partyId: vm.hashUrlReservationId,
          partyTypeId: 5,
          PaymentTypeId: vm.cardInfo.PaymentTypeId,
          NameOnCard: vm.cardToken.name,
          CreditCard: null,
          ExpirationYear: vm.cardInfo.ExpirationYear,
          ExpirationMonth: vm.cardInfo.ExpirationMonth,
          CCLast4Digits: vm.cardToken.last4,
          CvvCode: null,
          IsDefault: 1,
          AddressDetails: vm.cardInfo.AddressDetails,
          PostalCode: vm.cardInfo.PostalCode,
        },
        Token = vm.cardTokenFromStripe,
        cardId = vm.stripecardId,
        stripeConnectedAccount = vm.stripeConnectedAccount,
        stripePlatformAccount = vm.stripePlatformAccount;
      console.log("obj", vm.cardInfo);
      let sucessCallback = function (response) {
          console.log("response in savePaymentCardDetails", response);
          if (response && response.data) {
            // vm.$store.dispatch("toastr", {
            //     type: "success",
            //     header: "Success!",
            //     message: "Payments Saved Successfully!"
            // });
            // vm.ThankuPage = true;
            (vm.loading = false), (vm.enableCompleteButton = false);
            vm.showGuestDetails = true;
            vm.ShowPaymentDetails = false;
            vm.sendThankYouMail(vm.hashUrlReservationId);
            // vm.$router.push("/ThankYouPage/" + vm.hashUrlReservationId);
            Cookies.remove("idleTime");
            var date = new Date();
            date.setTime(date.getTime() + 30 * 60 * 1000);
            Cookies.set("idleTime", vm.$route.params.confirmationNumber, {
              expires: date,
            });
            vm.$router.push({
              name: "ThankYouPage",
              params: {
                confirmationNumber: vm.$route.params.confirmationNumber,
              },
            });
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/savePaymentDetails",
        "post",
        {
          paymentDetails: obj,
          Token,
          cardId,
          stripeConnectedAccount,
          stripePlatformAccount,
        },
        sucessCallback,
        failureCallback
      );
    },
    sendThankYouMail(id) {
      let vm = this,
        sucessCallback = function (response) {
          console.log("response in thankyouMail", response);
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/thankyouMail",
        "post",
        {
          ReservationId: id,
          protocol: window.location.protocol,
          confirmationNumber: vm.$route.params.confirmationNumber,
        },
        sucessCallback,
        failureCallback
      );
    },
    getPaymentDetails() {
      let vm = this,
        obj = {
          ReservationId: vm.hashUrlReservationId,
        };
      let sucessCallback = function (response) {
          console.log("response in Get_PaymentDetails", response);
          if (response && response.data) {
            // vm.paymentDetails = response[0];
            // vm.paymentCharges = response[1][0];
            vm.paymentLedgerAcounts = response.data.recordsets[2];
            vm.stripePlatformAccount = response.data.recordsets[3][0];
            vm.stripeConnectedAccount = response.data.recordsets[4][0];
            console.log("stripeConnectedAccount", vm.stripeConnectedAccount);
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/Get_PaymentDetails",
        "post",
        obj,
        sucessCallback,
        failureCallback
      );
    },
    getPaymentCardDetails() {
      let vm = this,
        obj = {
          ReservationId: vm.hashUrlReservationId,
        };
      let sucessCallback = function (response) {
          console.log("response in getPaymentCardDetails", response);
          if (
            response &&
            response.data &&
            response.data[0][0] &&
            response.data[0][0].NameOnCard
          ) {
            // vm.cardInfo = response.data[0][0];
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/Get_PaymentCardDetails",
        "post",
        obj,
        sucessCallback,
        failureCallback
      );
    },
    GetReservationDetailsByURL() {
      let vm = this,
        obj = {
          confirmationNumber: decodeURIComponent(
            vm.$route.params.confirmationNumber
          ),
        };
      console.log(
        "vm.$route.params.confirmationNumber",
        vm.$route.params.confirmationNumber
      );
      let sucessCallback = function (response) {
          console.log("response in getPaymentCardDetails", response);
          if (
            response &&
            response.data &&
            response.data.recordsets[0] &&
            response.data.recordsets[0][0]
          ) {
            // ExpireDate IsExpired
            if (response.data.recordsets[0][0].IsExpired == 1) {
              vm.showGuestInfo = false;
            } else {
              vm.showGuestInfo = true;
              vm.hashUrlReservationId =
                response.data.recordsets[0][0].ReservationId;
              vm.GetReservationDetailById();
              vm.getPaymentDetails();
              vm.getPaymentCardDetails();
              vm.Get_FolioSummary();
            }
          } else {
            vm.hashUrlReservationId = -1;
            vm.GetReservationDetailById();
            vm.getPaymentDetails();
            vm.getPaymentCardDetails();
            // vm.Get_FolioSummary();
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      vm.$store.state.sendApiRequest(
        "beApi/GetReservationDetailsByURL",
        "post",
        obj,
        sucessCallback,
        failureCallback
      );
    },
    initGMapWidth() {
      this.$nextTick(this.resizeEvent);
      window.addEventListener("resize", this.resizeEvent);
      // this.isLoading = false;
    },
    resizeEvent() {
      if (!this.$refs.guestInfo) {
        return;
      }
      setTimeout(() => {
        let vm = this;
        let cw = this.$refs.guestInfo.clientWidth;
        console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^", cw);
        if (cw <= 797 && cw != "768") {
          console.log("mmmmmmmmmmmmmmmmmmmmmmmmmm");
          vm.isWebView = false;
          if (window.innerHeight < window.innerWidth) {
            vm.showPriceInfo = true;
            vm.showPriceText = "Close";
            // if (vm.showGuestDetails) {
            //     setTimeout(() => {
            //         var etop = $(".guestWrap").offset().top + 195;
            //         $('html, body').animate({
            //             scrollTop: etop
            //         }, 350);
            //     }, 100)
            // }
            // else if (vm.ShowPaymentDetails) {
            //     setTimeout(() => {
            //         var etop = $(".paymentWrap").offset().top + 80;
            //         $('html, body').animate({
            //             scrollTop: etop
            //         }, 350);
            //     }, 100)
            // }
          } else {
            vm.showPriceInfo = false;
            vm.showPriceText = "Details";
          }
        } else {
          console.log("wwwwwwwwwwwwwwwwwwwwwwwwwwwww");
          vm.isWebView = true;
          vm.showPriceInfo = false;
          vm.showPriceText = "Details";
        }
      }, 100);
    },
    routeChangeEvent() {
        let vm =this
        if(vm.$gtag){
          vm.$gtag.pageview({
            page_title: 'Guest Info-Page',
            page_location: window.location.href,
            page_path: vm.$route.path,
          })
        }
    },
  },
  computed: {
    expiryYears() {
      let currYear = new Date().getFullYear();
      let years = [];
      years.push(currYear);
      for (let yIndex = 1; yIndex <= 16; yIndex++) {
        years.push(currYear + yIndex);
      }
      return years;
    },
    unit() {
      let vm = this;
      console.log(
        "this.$store.getters.getUnitsData",
        vm.$store.getters.getUnitsData
      );
      return vm.$store.getters.getUnitsData;
    },
    filterObj() {
      let vm = this;
      console.log(
        "this.$store.getters.getAvailableUnitsList",
        this.$store.getters.getFilteredData
      );
      // vm.getAvailableRooms();
      return this.$store.getters.getFilteredData;
    },
    isVaildSubDomain() {
      let vm = this;
      return vm.$store.state.isValidDomainOrNot;
    },
    beCssObj() {
      if (this.$store.state.cssObj) return this.$store.state.cssObj;
      return null;
    },
    mapWraperLoaded() {
      return this.isVaildSubDomain;
    },
  },
  mounted() {
    let vm = this;
    // vm.GetReservationDetailById();
    // if (vm.$route.params.confirmationNumber == -1) {
    //     vm.showGuestChangeButton = false;
    // }
    // else {
    //     vm.showGuestChangeButton = true;
    // }
    // vm.showGuestChangeButton = true;
    vm.$store.state.bus.$emit("hidingSearch", false);
    setTimeout(() => {
      if(vm.$gtag){
      vm.$gtag.pageview({
                    page_title: 'Guest Info-Page',
                    page_location: window.location.href,
                    page_path: vm.$route.path,
                })
              }
    }, 100);
    vm.GetReservationDetailsByURL();
    if (this.$store.state.cssObj) {
      var para = document.createElement("style");
      para.innerText = this.$store.state.cssObj;
      //console.log("para.innerText", para.innerText);
      var body = document.getElementById("BETemplateBody");
      body.appendChild(para);
    }
    // setTimeout(() => {
    //     this.resizeEvent();
    //     window.addEventListener('resize', this.resizeEvent);
    // }, 100)
    if (this.mapWraperLoaded) {
      this.initGMapWidth();
    }
  },
  watch: {
    mapWraperLoaded(newValue, oldValue) {
      console.log("newValue", newValue);
      if (newValue !== oldValue && newValue === true) {
        this.initGMapWidth();
      }
    },
    isVaildSubDomain(isAvail) {
      if (isAvail) {
        this.GetReservationDetailById();
        this.getPaymentDetails();
        this.getPaymentCardDetails();
        this.GetFolioLedgerTransDetails_beforesave();
        this.GetReservationDetailsByURL();
      }
    },
    beCssObj() {
      //console.log(this.beCssObj);
      if (this.beCssObj) {
        var para = document.createElement("style");
        para.innerText = this.beCssObj;
        //console.log("para.innerText", para.innerText);
        var body = document.getElementById("BETemplateBody");
        body.appendChild(para);
      }
    },
    searchCity(newValue, oldValue) {
      let vm = this;
      vm.cityList = [];
      vm.guestInfo.CityName = newValue;
      let obj = {
        ModuleAction: "GetCitySearch",
        SearchLocation: newValue,
        SearchId: 1,
      };
      let sucessCallback = function (response) {
          console.log("response in searchCity", response);
          if (response.data) {
            if (newValue && oldValue) {
              //console.log("vm.cityList", vm.cityList)
              vm.cityList = response.data;
            }
            console.log(" vm.cityList", vm.cityList);
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      if (vm.searchCityOldValue != vm.searchCity) {
        if (newValue.length > 0) {
          vm.$store.state.sendApiRequest(
            "beApi/GetCitySearch",
            "post",
            obj,
            sucessCallback,
            failureCallback
          );
        }
      }
    },
    searchState(newValue, oldValue) {
      let vm = this;
      vm.stateList = [];
      vm.guestInfo.StateName = newValue;
      if (vm.selectedStateAndCountry.StateName != newValue && oldValue)
        vm.selectedStateAndCountry.StateId = null;
      vm.guestInfo.StateName = newValue;
      let obj = {
        ModuleAction: "GetCitySearch",
        SearchLocation: newValue,
        SearchId: 2,
      };
      let sucessCallback = function (response) {
          console.log("response in searchState", response);
          if (response.data) {
            if (newValue && oldValue) {
              vm.stateList = response.data;
            }
            // console.log(" vm.stateList", vm.stateList);
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      if (vm.searchStateOldValue != vm.searchState) {
        if (newValue.length > 0) {
          vm.$store.state.sendApiRequest(
            "beApi/GetCitySearch",
            "post",
            obj,
            sucessCallback,
            failureCallback
          );
        }
      }
    },
    searchCountry(newValue, oldValue) {
      let vm = this;
      vm.countryList = [];
      vm.guestInfo.CountryName = newValue;
      if (vm.selectedStateAndCountry.CountryName != newValue && oldValue)
        vm.selectedStateAndCountry.CountryId = null;
      vm.guestInfo.CountryName = newValue;
      let obj = {
        ModuleAction: "GetCitySearch",
        SearchLocation: newValue,
        SearchId: 3,
      };
      let sucessCallback = function (response) {
          console.log("response in searchCountry", response);
          if (response.data) {
            if (newValue && oldValue) {
              vm.countryList = response.data;
            }
            console.log(" vm.countryList", vm.countryList);
          }
        },
        failureCallback = function (error) {
          console.log(error);
        };
      if (vm.searchCountryOldValue != vm.searchCountry) {
        if (newValue.length > 0) {
          vm.$store.state.sendApiRequest(
            "beApi/GetCitySearch",
            "post",
            obj,
            sucessCallback,
            failureCallback
          );
        }
      }
    },
    $route: "routeChangeEvent",
  },
  created() {
    let vm = this;
    $("html, body").animate({ scrollTop: 0 });
    vm.GetReservationDetailsByURL();
    vm.GetReservationDetailById();
    vm.GetFolioLedgerTransDetails_beforesave();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeEvent);
    // window.removeEventListener('scroll', this.callWindowScrollEvent);
    // $(window).unbind('scroll');
    // this.prevScrollpos = 0;
    // document.getElementById("page-content").style.padding = "";
  },
};
</script>


// WEBPACK FOOTER //
// src/components/guestInfoDetails/guestInfoDetails.vue